module.exports = __webpack_public_path__ + "assets/img/login-phone-email.b885a23.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/login-phone-email.png
// module id = Gp8K
// module chunks = 50